import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_HELP_ARTICLES_QUERY_KEY } from './useHelpArticles';
import { GET_HELP_CATEGORIES_QUERY_KEY } from './useHelpCategories';

export const useDeleteHelpArticle = (onSuccess: () => void) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      client.fetchApi<void, {}>({ endpoint: `help/admin/articles/${id}`, method: 'DELETE' }),
    onSuccess: () => {
      queryClient.invalidateQueries(GET_HELP_ARTICLES_QUERY_KEY);
      queryClient.invalidateQueries(GET_HELP_CATEGORIES_QUERY_KEY);
      onSuccess();
    },
  });
};
